import { PropsWithChildren } from "react";
import { AuthRoutes } from "ui/auth/router/AuthRouter";
import useIsLoggedIn from "ui/auth/hooks/useIsLoggedIn";
import ProtectedRoute from "ui/router/components/ProtectedRoute/ProtectedRoute";

const LoggedInRoute = ({ children }: PropsWithChildren<Record<string, unknown>>): JSX.Element => {
    const isLoggedIn = useIsLoggedIn();

    return (
        <ProtectedRoute isAllowed={isLoggedIn} redirectPath={AuthRoutes.LOGIN}>
            {children}
        </ProtectedRoute>
    );
};

export default LoggedInRoute;
